exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quiz .cta-container .button {\n  height: 46px;\n  font-family: \"Lato\";\n  line-height: 46px;\n  font-size: 14px;\n  min-width: auto;\n}\n.quiz .cta-container .quiz-buttons > :nth-child(1) {\n  margin-right: 10px;\n}\n.quiz .cta-container .quiz-buttons .button {\n  flex: 0.46;\n  padding: 0 20px;\n}\n.quiz .cta-container .quiz-buttons .main-button {\n  flex: 0.8;\n}", ""]);

// exports
